import { useState } from "react";

export function TextExpander({ children = "", words = 80 }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!children) return null;

  const wordsArray = children?.split(" ");
  const shouldShowButton = wordsArray?.length > words;
  const displayText = isExpanded ? children : shouldShowButton ? wordsArray?.slice(0, words)?.join(" ") + "..." : children;

  return (
    <span>
      {displayText}
      {shouldShowButton && (
        <span style={{ fontSize: "1rem" }} className="text-primary fw-bold px-2" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? "Show less" : "Show more"}
        </span>
      )}
    </span>
  );
}
